<template>
  <div>
    <stepTitle :navItems="['Live Culture']" :index="1" :step="1"/>
    <div class="container">
      <div class="cloud row mx-auto align-items-center py-5 ">
        <div class="col-12 mb-5">
          <div class="d-flex justify-content-between px-5">
            <div></div>
            <h5 class="m-auto">{{$t('select_unit')}}</h5>
            <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../assets/image/icon/close_lesson.png" />
          </div>
        </div>
        <div v-for="(item,index) in countrys" :key="index" class="col-lg-3 col-sm-6">
          <div @click="goUnit(item.id)" class="unit-box">
            <img :src="item.pic" style="width:100%"/>
            <h5>
              <span v-if="$i18n.locale==='tw'">
                {{item.name}}
              </span>
              <br/>
              <span>
                {{item.englishName}}
              </span>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stepTitle from '../../Teacher/StepTitle'
import api from '../../../store/api'
export default {

  name: 'AROptions',
  data () {
    return {
      countrys: []
    }
  },
  components: {
    stepTitle
  },
  mounted () {
    this.getCountry()
    console.log(this.$i18n.locale)
  },
  methods: {
    goUnit (num) {
      this.$router.push({name: 'ar_lesson', params: { id: num, page: 1 }})
    },
    async getCountry () {
      const { data } = await api.get('/Globetrotting/Country')
      if (data.status === 'OK') {
        this.countrys = data.data
        let pic = ['us', 'br', 'eg', 'fr', 'gb', 'de', 'ru', 'jp', 'in', 'au']
        let englishName = ['The US', 'Brazil', 'Egypt', 'France', 'The UK', 'Germany', 'Russia', 'Japan', 'India', 'Australia']
        this.countrys.map((el, count) => {
          el.pic = require(`../../../assets/image/cloud/btn_flag_${pic[count]}.png`)
          el.englishName = englishName[count]
        })
      }
    },
    previousPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
	.unit-box {
		cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
		width: 100%;
		margin: auto;
		margin-bottom: 30px;
		position: relative;
		h5 {
			width: 100%;
			position: absolute;
			bottom: 40px;
    }
    &:hover {
      // -webkit-filter: drop-shadow(0px 0px 8px #a1a1a1);
      filter: drop-shadow(0px 0px 8px #a1a1a1)
    }
	}
	@media screen and (min-width: 768px) {
    .cloud {
			width:80%;
		}
	}
</style>


// WEBPACK FOOTER //
// Options.vue?d35c2b8c